//   COMPANY NAME
//  FOR LOCAL USE
const SERVER_IP = "localhost";
const SERVER_PORT = "8000";

export const TRANSPORTER_NAME = "VEER EXPRESS"
export const TRANSPOTER_GSTIN = "24AELFS3755D1ZZ"
export const SERVER_URL = "http://103.250.153.183:8000";
// export const SERVER_URL = "http://" + SERVER_IP + ":" + SERVER_PORT;



